import { mapState } from 'vuex';
import { _checkValidityDate, _prepareErrors, _restApiDataFormatting } from '@/utils/_function.js';
import * as Api from '@/api';

export default {
  name: 'Profile',
  data() {
    return {
      isProfilePage: false,
      fields: [
        {
          key: 'proprietorName',
          label: 'Название',
          sortable: true
        },
        {
          key: 'filerEmail',
          label: 'Email'
        },
        {
          key: 'validity',
          label: 'Срок действия доверенности'
        }
      ],
      qrcode: null,
      error: {
        qrcode: null
      }
    };
  },
  watch: {
    'qrcode': function() {
      this.error.qrcode = null;
    }
  },
  mounted() {
    if (this.$router.history.current.name === 'Profile') {
      this.isProfilePage = true;
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.authUser,
      isActive2fa: state => state.isActive2fa
    })
  },
  methods: {
    goBack() {
      this.$router.push({ path: `/logout` });
    },

    editData() {
      this.$router.push({ path: '/edit-profile' });
    },

    checkValidity(dateTo) {
      return _checkValidityDate(dateTo);
    },

    onCopy: function(e) {
      this.$toastr('success', this.$t('clipboard.success'));
    },

    onError: function(e) {
      this.$toastr('error', this.$t('clipboard.error'), 'Ошибка');
    },

    activate2fa() {
      this.isDataSave = true;

      if (this.qrcode) {
        const checkValidationCode = /^\d{6}/i.test(this.qrcode);
        if (!checkValidationCode) {
          this.error.qrcode = 'Код должен содержать 6 цифр.';
          return;
        }
      }

      Api.activate2fa({ data: { otpPassword: this.qrcode } })
        .then((response) => {
          if (response) {
            this.$store.dispatch('setPersonalDetailAuthUser', _restApiDataFormatting(response));
            this.$store.dispatch('refreshState');
            this.$toastr('success', this.$t('activate2fa.success'));
          }
        })
        .catch((errors) => {
          if (errors) {
            _prepareErrors(errors).forEach((err) => {
              this.$toastr('error', err, 'Ошибка');
            });

            this.$toastr('error', this.$t('activate2fa.error'), 'Ошибка');
          }

          this.isDataSave = false;
        });
    }
  }
};
